module.exports = __webpack_public_path__ + "img/140.eilat_resident.3be42f77.svg";